import { render, staticRenderFns } from "./404.vue?vue&type=template&id=a7b65ce2&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=a7b65ce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b65ce2",
  null
  
)

export default component.exports